import { render, staticRenderFns } from "./ProfileAndCategoriesMD.vue?vue&type=template&id=8a86baa0&scoped=true"
import script from "./ProfileAndCategoriesMD.vue?vue&type=script&lang=js"
export * from "./ProfileAndCategoriesMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a86baa0",
  null
  
)

export default component.exports